import { Component, Input, Inject, OnInit } from '@angular/core';

import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./../models/types";

import { OrganizationEventType } from '../../../../../common/models/organization.model';


@Component({
    selector: 'create-organization-history-entry',
    templateUrl: './side-effect-create-organization-history-entry.component.html',
    standalone: false
})
export class SideEffectCreateOrganizationHistoryEntryComponent implements OnInit {
    _seConfiguration: any;

    historyEntryTypes = Object.entries(OrganizationEventType).filter(x => this.isNumeric(x[0])).map(([key, value]) => ({ word: key, number: value }))
    
    set seConfiguration(value: any) {
        this._seConfiguration = value ||{};
        this._seConfiguration.organizationId = this._seConfiguration.organizationId||''; 
        this._seConfiguration.eventType = this._seConfiguration.eventType || '';               
    }

    get seConfiguration(): any {
        return this._seConfiguration;
    }

    get selectedEventType(): number {
        if (this._seConfiguration == null || this._seConfiguration.eventType == null) return;
        return parseInt(this._seConfiguration.eventType.toString());
    }

    set selectedEventType(value: number) {
        this._seConfiguration.eventType = value;
    }
    
    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.seConfiguration = data.configuration;
    }

    ngOnInit() {
    }

    private isNumeric(value: any): boolean {
        if (value == null) return false;
        return isNaN(value);
    }
}
